import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useLocation, useParams } from "react-router";
import Alert from "../../../Components/Alert/alert";
import { HiCog, HiKey, HiOutlineCamera } from "react-icons/hi";
import Dropdown from "../../../Components/Dropdown/dropdown";
import { Url, getUser } from "../../../Constants/globals";
import Switch from "../../../Components/Switch/switch";
import Loading from "../../../Components/Loading/loading";
import GoBack from "../../../Components/GoBack/goback";
import stylesModal from "../../../Components/DeleteModal/deletemodal.module.css";
import DeleteModal from "../../../Components/DeleteModal/deletemodal";

function ModalPassword({ name, nif, closeModal, setAlert, setLoading }) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);

  async function changePassword() {
    await setAlert("");
    await setLoading(<Loading />);
    try {
      await axios.post(`${Url}/reset-user-password`, {
        nif: nif
      }, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
      await setLoading("");
      await handleClose();
      return setAlert(<Alert type={"success"}>Palavra-passe redefinida com sucesso</Alert>)
    }
    catch (err) {
      if (err.request && err.request.status === 401) {
        var newToken = await RefreshToken(err);
        if (newToken) return await changePassword();
        else window.location.reload();
      }
      else {
        console.error(err);
        setLoading("");
        return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao redefinir a palavra-passe"}</Alert>);
      }
    };
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      <div className={stylesModal.center}>
        <div className={stylesModal.column}>
          <h4 style={{ margin: 0 }}>Ao redefinir a palavra-passe, esta tomará o valor do NIF do utilizador.</h4>
          <h4 style={{ margin: 0 }}>Deseja redefinir a palavra-passe de {name} para {nif}?</h4>
          <div className={stylesModal.buttons}>
            <button className={stylesModal.actionButton} onClick={() => changePassword()}>Redefinir palavra-passe</button>
            <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ResizeModal({ closeModal, image, setFile, setSelectedFile }) {

  const img = new Image();
  const [currentImage, setCurrentImage] = useState("");
  const [realestSize, setRealestSize] = useState(0);
  const [realSize, setRealSize] = useState(0);
  const [loadingImg, setLoadingImg] = useState(true);
  const [isPoppedOut, setIsPoppedOut] = useState(false);
  const [widthBigger, setWidthBigger] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const dragItem = useRef();
  const dragItemPosition = useRef({ x: 0, y: 0 });
  const [toolSize, setToolSize] = useState(0);
  const containerRef = useRef();

  function getImageDimensions() {
    const imageObj = URL.createObjectURL(image);
    img.src = imageObj;
    img.onload = () => {
      const aspectRatio = img.width / img.height;
      if (img.width > img.height) {
        setRealestSize(img.height);
        setRealSize(350 / aspectRatio);
        setWidthBigger(true);
      }
      else {
        setRealestSize(img.width);
        setRealSize(350 * aspectRatio);
      }
    };
    setCurrentImage(imageObj);
    setLoadingImg(false);
  }

  useEffect(() => {
    getImageDimensions();
  }, []);

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  const onMouseDown = (e) => {
    dragItem.current = e.target;
    dragItemPosition.current = {
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    };
    setIsDragging(true);
  };

  const onMouseMove = (e) => {
    if (isDragging) {
      const container = containerRef.current;
      const containerRect = container.getBoundingClientRect();
      const itemRect = dragItem.current.getBoundingClientRect();

      let newX = e.clientX - dragItemPosition.current.x;
      let newY = e.clientY - dragItemPosition.current.y;

      if (newX < 0) newX = 0;
      if (newY < 0) newY = 0;
      if (newX + itemRect.width > containerRect.width)
        newX = containerRect.width - itemRect.width;
      if (newY + itemRect.height > containerRect.height)
        newY = containerRect.height - itemRect.height;

      setPosition({ x: newX, y: newY });
    }
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const calculateRelativePosition = async () => {
    const container = containerRef.current;
    const itemRect = dragItem.current.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const relativeX = itemRect.left - containerRect.left;
    const relativeY = itemRect.top - containerRect.top;

    return { x: relativeX, y: relativeY };
  };

  const cropImage = (crop) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const { x, y, width, height } = crop;

    canvas.width = width;
    canvas.height = height;

    const img = new Image();
    img.src = currentImage;

    return new Promise((resolve) => {
      img.onload = () => {
        ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
        resolve(canvas.toDataURL());
      };
    });
  };

  const dataURLToBlob = (dataURL) => {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  function dataURLToFile(dataURL) {
    const blob = dataURLToBlob(dataURL);
    return new File([blob], image.name, { type: blob.type });
  }

  async function confirmPhoto() {
    const realSizeWithTool = realSize + toolSize;
    const divideValue = realestSize / realSize;
    const dimensions = await calculateRelativePosition();
    const crop = { x: dimensions.x * divideValue, y: dimensions.y * divideValue, width: realSizeWithTool * divideValue, height: realSizeWithTool * divideValue };
    const croppedDataUrl = await cropImage(crop);
    const blobToFile = dataURLToFile(croppedDataUrl);
    setFile(blobToFile);
    setSelectedFile(croppedDataUrl);
    return handleClose();
  }

  useEffect(() => {
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  useEffect(() => {
    const handleScroll = (event) => {
      if (event.deltaY < 0 && realSize + toolSize > 151) {
        setToolSize((prevSize) => prevSize - 1); // Scroll up, decrease size
      }
      else if (toolSize < 0) {
        setToolSize((prevSize) => prevSize + 1); // Scroll down, increase size
      }
    };

    const circle = dragItem.current;
    if (circle) {
      circle.addEventListener('wheel', handleScroll);

      return () => {
        circle.removeEventListener('wheel', handleScroll);
      };
    }
  }, [dragItem, realSize, toolSize]);

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      {
        loadingImg ? ""
          :
          <div className={stylesModal.center}>
            <div className={stylesModal.column}>
              <h4 style={{ margin: 0 }}>Definir posição da imagem</h4>
              <span style={{ fontSize: "10pt" }}>(Scroll para ajustar tamanho)</span>
              <div
                ref={containerRef}
                className={styles.imageResizeDiv}
                onMouseMove={(e) => onMouseMove(e)}
                onMouseUp={() => onMouseUp()}
                onMouseLeave={() => onMouseUp()}
              >
                <img className={styles.fotoResize} style={widthBigger ? { width: "350px", padding: 0 } : { height: "350px", padding: 0 }} alt="img" src={currentImage ? currentImage : ""} />
                <div
                  ref={dragItem}
                  className={styles.resizeTool}
                  onMouseDown={(e) => onMouseDown(e)}
                  style={{ width: realSize + toolSize, height: realSize + toolSize, transform: `translate(${position.x}px, ${position.y}px)` }}
                >
                  <div className={styles.resizeCircle} />
                </div>
              </div>
              <div className={stylesModal.buttons}>
                <button className={stylesModal.actionButton} onClick={() => confirmPhoto()}>Confirmar</button>
                <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
              </div>
            </div>
          </div>
      }
    </div>
  );
}

async function getCompanies(page) {
  try {
    const res = await axios
      .get(`${Url}/companies?page=${page ? page : 1}&order_by=name`, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanies(page);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getProfiles() {
  try {
    const res = await axios
      .get(`${Url}/profiles?per_page=100&order_by=name`, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getProfiles();
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getPermissions() {
  try {
    const res = await axios.get(`${Url}/application-tabs`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    for (const perm of res.data) {
      perm.value = false;
    }
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getPermissions();
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getEmployeeDetails(id) {
  try {
    const res = await axios.get(`${Url}/users/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await getEmployeeDetails(id);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function addEmployee(nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, backoffice, uniqueID) {
  if (nif.trim() === "" || fullName.trim() === "" || firstName.trim() === "" || lastName.trim() === "" || empresa === "" || nColaborador.trim() === "" || profile === "") {
    return ["", <Alert type={"error"}>Os campos nome completo, primeiro e último nome, NIF, número de colaborador, empresa e perfil são obrigatórios</Alert>];
  }
  if (backoffice && email.trim() === "") {
    return ["", <Alert type={"error"}>O campo email é obrigatório para utilizadores com acesso ao backoffice</Alert>];
  }

  try {
    const response = await axios.post(`${Url}/users`,
      {
        nif: nif,
        full_name: fullName,
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: contacto,
        company_id: empresa.id,
        num: nColaborador,
        backoffice: backoffice,
        approved: true,
        birthday: birthday,
        profile: profile.id,
        unique_identifier: uniqueID ? uniqueID : null,
      }, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [response.data, <Alert type={"success"}>Funcionário adicionado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await addEmployee(nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, backoffice, uniqueID);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o funcionário");
      return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o funcionário"}</Alert>];
    }
  };
}

async function saveEmployee(id, nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, backoffice, uniqueID) {
  if (nif.trim() === "" || fullName.trim() === "" || firstName.trim() === "" || lastName.trim() === "" || empresa === "" || nColaborador.trim() === "" || profile === "") {
    return ["", <Alert type={"error"}>Os campos NIF, nome completo, primeiro e último nome, número de colaborador, empresa e perfil são obrigatórios</Alert>];
  }
  if (backoffice && email.trim() === "") {
    return ["", <Alert type={"error"}>O campo email é obrigatório para utilizadores com acesso ao backoffice</Alert>];
  }

  try {
    await axios.put(`${Url}/users/${id}`,
      {
        nif: nif,
        first_name: firstName,
        last_name: lastName,
        full_name: fullName,
        email: email,
        phone: contacto,
        num: nColaborador,
        backoffice: backoffice,
        company_id: empresa.id,
        approved: true,
        birthday: birthday,
        profile: profile.id,
        unique_identifier: uniqueID ? uniqueID : null
      }, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return <Alert type={"success"}>Funcionário editado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await saveEmployee(id, nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, backoffice, uniqueID);
      }
      else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o funcionário");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o funcionário"}</Alert>;
    }
  };
}

async function handleUserDefaultPermissions(userPermissions, allPermissions, setPermissions) {
  let userPermissionsIds = [];
  let tempAllPermissions = [...allPermissions];
  for (const userPermission of userPermissions) {
    userPermissionsIds.push(userPermission.id);
  }
  for (const perm of tempAllPermissions) {
    if (userPermissionsIds.includes(perm.id)) {
      perm.value = true;
    }
  }
  return setPermissions(tempAllPermissions);
}

async function deleteEmployeeFunction(id, reason) {
  if (!reason) {
    return [0, <Alert type={"error"}>Apresente um motivo</Alert>];
  }
  try {
    await axios.delete(`${Url}/users/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
      data: {
        reason: reason,
      },
    });
    return [200, <Alert type={"success"}>Funcionário eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await deleteEmployeeFunction(id, reason);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o funcionário"}</Alert>];
    }
  };
}

async function changeActivityEmployeeFunction(id, reason) {
  if (!reason) {
    return [0, <Alert type={"error"}>Apresente um motivo</Alert>];
  }
  try {
    await axios
      .post(`${Url}/users/${id}/activity`,
        {
          reason: reason
        },
        {
          headers: {
            Authorization: "Bearer " + getUser().token,
          },
        });
    return [200, <Alert type={"success"}>Funcionário desativado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401) {
      var newToken = await RefreshToken(err);
      if (newToken) return await changeActivityEmployeeFunction(id, reason);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao desativar o funcionário"}</Alert>];
    }
  };
}

function EditarFuncionarios({ userPermissions }) {

  const location = useLocation();
  const { state } = location;
  const [loading, setLoading] = useState("");
  const { id } = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [imageHover, setImageHover] = useState(false);
  const [alert, setAlert] = useState("");

  const [resizeModal, setResizeModal] = useState("");
  const [modalPassword, setModalPassword] = useState("");
  const [deleteEmployee, setDeleteEmployee] = useState("");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fullName, setFullName] = useState("");
  const [nif, setNif] = useState("");
  const [nColaborador, setNColaborador] = useState("");
  const [email, setEmail] = useState("");
  const [birthday, setBirthday] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [img, setImg] = useState("");
  const [uniqueId, setUniqueId] = useState("");

  const [accessBackoffice, setAccessBackoffice] = useState(false);
  const [permissions, setPermissions] = useState([]);

  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState("");

  const [profiles, setProfiles] = useState([]);
  const [profile, setProfile] = useState("");

  const [empresas, setEmpresas] = useState([]);
  const [nextEmpresas, setNextEmpresas] = useState("");
  const [firstLoadEmpresas, setFirstLoadEmpresas] = useState(true);
  const [empresa, setEmpresa] = useState("");
  const [approvedImg, setApprovedImg] = useState(false);
  const [contacto, setContacto] = useState("");
  const [alreadyHasUniqueId, setAlreadyHasUniqueId] = useState(false);

  const fileInputRef = useRef(null);

  const handleImageUpload = () => fileInputRef.current.click();

  const handleFileChange = async (event) => {
    if (event?.target?.files[0]) {
      setResizeModal(<ResizeModal closeModal={setResizeModal} image={event.target.files[0]} setFile={setFile} setSelectedFile={setSelectedFile} />);
    }
  };

  async function assignData() {
    const thisEmployeeDetailsData = await getEmployeeDetails(id);
    const allPermissions = await getPermissions();
    await handleUserDefaultPermissions(thisEmployeeDetailsData.permissions, allPermissions, setPermissions);
    if (thisEmployeeDetailsData.photo_uri) setImg(thisEmployeeDetailsData.photo_uri);
    setFirstName(thisEmployeeDetailsData.first_name);
    setLastName(thisEmployeeDetailsData.last_name);
    setFullName(thisEmployeeDetailsData.full_name);
    setNif(thisEmployeeDetailsData.nif);
    setNColaborador(thisEmployeeDetailsData.num ?? "");
    setContacto(thisEmployeeDetailsData.phone ?? "");
    setProfile(thisEmployeeDetailsData.profile ?? "");
    setEmail(thisEmployeeDetailsData.email);
    setBirthday(thisEmployeeDetailsData.birthday ?? "");
    setIsActive(thisEmployeeDetailsData.is_active);
    setEmpresa(thisEmployeeDetailsData.company);
    setApprovedImg(thisEmployeeDetailsData.approved);
    setAccessBackoffice(thisEmployeeDetailsData.backoffice);
    if (thisEmployeeDetailsData.unique_identifier) setAlreadyHasUniqueId(true);
    else setAlreadyHasUniqueId(false);
    setLoadingData(false);
  }

  async function getAlertEdit() {
    await setLoading(<Loading />);
    await setAlert("");
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await axios.post(Url + '/users/' + id + '/image/', formData, {
          headers: {
            Authorization: "Bearer " + getUser().token,
            'Content-Type': 'multipart/form-data'
          }
        });
      } catch (err) {
        if (err.request && err.request.status === 401) {
          var newToken = await RefreshToken(err);
          if (newToken) {
            return await getAlertEdit();
          }
          else {
            window.location.reload();
          }
        }
        else {
          setLoading("");
          console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a foto");
          return setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a foto"}</Alert>);
        }
      }
    }
    const resPermissions = await addEmployeePermissions(id, permissions);
    if (resPermissions) {
      setLoading("");
      return setAlert(resPermissions);
    }
    const res = await saveEmployee(id, nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, accessBackoffice, uniqueId);
    assignData();
    setLoading("");
    return setAlert(res);
  }

  async function addEmployeeFile(employeeId) {
    const formData = new FormData();
    formData.append('file', file);
    try {
      await axios.post(Url + '/users/' + employeeId + '/image/', formData, {
        headers: {
          Authorization: "Bearer " + getUser().token,
          'Content-Type': 'multipart/form-data'
        }
      });
    }
    catch (err) {
      if (err.request && err.request.status === 401) {
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addEmployeeFile(employeeId);
        }
        else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir foto");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir foto"}</Alert>;
      }
    }
  }

  async function addEmployeePermissions(employeeId, permissions) {
    let userPermissions = [];
    for (const permission of permissions) {
      if (permission.value) userPermissions.push(permission.id);
    }

    try {
      await axios.post(`${Url}/user-permissions?user_id=${employeeId}`, {
        permissions: userPermissions
      },
        {
          headers: {
            Authorization: "Bearer " + getUser().token
          }
        });
    }
    catch (err) {
      if (err.request && err.request.status === 401) {
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await addEmployeePermissions(employeeId, permissions);
        }
        else {
          window.location.reload();
        }
      }
      else {
        console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir permissões");
        return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao atribuir permissões"}</Alert>;
      }
    }
  }

  async function getAlertAdd() {
    await setLoading(<Loading />);
    await setAlert("");
    const res = await addEmployee(nif, firstName, lastName, fullName, email, contacto, empresa, nColaborador, birthday, profile, accessBackoffice, uniqueId);
    if (res[0].id) {
      const resEmployee = await addEmployeePermissions(res[0].id, permissions);
      if (resEmployee) res[1] = resEmployee;
      if (file) {
        const resFile = await addEmployeeFile(res[0].id);
        if (resFile) res[1] = resFile;
      }
    }
    setLoading("");
    setAlert(res[1]);
  }

  useEffect(() => {
    if (id) assignData();
    else {
      fetchPermissionsData();
      setLoadingData(false);
    }
  }, []);

  async function fetchPermissionsData() {
    const thisPermissionsData = await getPermissions();
    setPermissions(thisPermissionsData);
  }

  async function fetchProfilesData() {
    const thisProfilesData = await getProfiles();
    setProfiles(thisProfilesData);
  }

  useEffect(() => {
    fetchProfilesData();
  }, []);

  async function fetchCompaniesData(page) {
    const thisCompaniesData = await getCompanies(page);
    setNextEmpresas(thisCompaniesData.next_page);
    if (firstLoadEmpresas) {
      setEmpresas(thisCompaniesData.companies);
      setFirstLoadEmpresas(false);
    }
    else setEmpresas(prevCompanies => [...prevCompanies, ...thisCompaniesData.companies]);
  }

  useEffect(() => {
    fetchCompaniesData();
  }, []);

  function handleHoverIn() {
    setImageHover(true);
  }
  function handleHoverOut() {
    setImageHover(false);
  }

  async function getAlertDelete(id, reason) {
    if (id) {
      await setAlert("");
      const res = await deleteEmployeeFunction(id, reason);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  async function getAlertActivity(id, reason) {
    if (id) {
      await setAlert("");
      const res = await changeActivityEmployeeFunction(id, reason);
      setAlert(res[1]);
      assignData();
      return res;
    }
  }

  return (
    <div className="body">
      {loading}
      {resizeModal}
      {modalPassword}
      {deleteEmployee}
      {alert}
      <NavBar current={"colaboradores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
          :
          <div className={styles.content}>
            <GoBack backRoute={`/colaboradores`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "", numSearch: state.numSearch ?? "", emailSearch: state.emailSearch ?? "", empresasSearch: state.empresasSearch?.length > 0 ? state.empresasSearch : [], order: state.order ? state.order : ["", ""] } : {}} />
            {
              id
                ?
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                  {
                    isActive ?
                      ""
                      :
                      <div className={styles.deadUser}>
                        desativado
                      </div>
                  }
                  <h1 className={styles.backgroundName}>{nColaborador ? nColaborador + " - " : ""} {firstName} {lastName}</h1>
                  {
                    isActive ?
                      <HiKey title="Redefinir palavra-passe" className={styles.icon} onClick={() => setModalPassword(<ModalPassword name={fullName} nif={nif} closeModal={setModalPassword} setAlert={setAlert} setLoading={setLoading} />)} size={30} />
                      : ""
                  }
                  <HiCog className={styles.icon} onClick={() => setDeleteEmployee(<DeleteModal close={setDeleteEmployee} user={true} objectId={id} objectName={fullName} deleteFunction={getAlertDelete} reason={true} userActivity={isActive} changeActivity={getAlertActivity} />)} size={30} />
                </div>
                :
                <h1 className={styles.backgroundName}>Adicionar funcionário</h1>
            }
            {
              file ?
                <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => handleFileChange(e)}
                    style={{ display: "none" }}
                  />
                  <img className={styles.foto} alt="img" src={selectedFile ? selectedFile : ""} />
                  {
                    imageHover ?
                      <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                        <HiOutlineCamera size={40} color="#fff" />
                        <p>Alterar foto</p>
                      </div>
                      : ""
                  }
                </div>
                : img && approvedImg ?
                  <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }}
                    />
                    <img className={styles.foto} alt="img" src={`${Url}/image/${img}`} />
                    {
                      imageHover ?
                        <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                          <HiOutlineCamera size={40} color="#fff" />
                          <p>Alterar foto</p>
                        </div>
                        : ""
                    }
                  </div>
                  // : fullName.includes("Pedro") ?
                  //   <div className={styles.imageDiv}>
                  //     <iframe width="170"
                  //     src="https://www.youtube.com/embed/jw3jjN8kCyo?autoplay=1"
                  //     title="YouTube video player"
                  //     frameborder="0"
                  //     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  //     allowfullscreen></iframe>
                  //     <a href="https://www.youtube.com/shorts/jw3jjN8kCyo">PEDRO</a>
                  //   </div>
                  :
                  <div className={styles.imageDiv} onMouseEnter={() => handleHoverIn()} onMouseLeave={() => handleHoverOut()} onClick={() => setImageHover(true)}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }}
                    />
                    <img className={styles.noFoto} alt="logo" />
                    {
                      imageHover ?
                        <div className={styles.changeImage} onClick={() => handleImageUpload()}>
                          <HiOutlineCamera size={40} color="#fff" />
                          <p>Alterar foto</p>
                        </div>
                        : ""
                    }
                  </div>
            }
            <div className={styles.formBlock}>
              <div className={styles.formBlockSection} style={{ gridColumnStart: 1, gridColumnEnd: 3 }}>
                <p>Nome completo:</p>
                <input
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>Primeiro nome (exibido na app):</p>
                <input
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>Último nome (exibido na app):</p>
                <input
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>NIF:</p>
                <input
                  value={nif}
                  onChange={(e) => setNif(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>Nº Colaborador:</p>
                <input
                  value={nColaborador}
                  onChange={(e) => setNColaborador(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>Email:</p>
                <input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className={styles.formBlockSection}>
                <p>Contacto:</p>
                <input
                  value={contacto}
                  onChange={(e) => setContacto(e.target.value)}
                />
              </div>
              <Dropdown
                label={"Empresa:"}
                placeholder={"Escolher empresa"}
                items={empresas}
                onUrlChange={fetchCompaniesData}
                value={empresa}
                onValueChange={setEmpresa}
                nextUrl={nextEmpresas}
              />
              {/* <MultiSelect
              items={notificationGroups}
              label={"Campanhas:"}
              placeholder={"Associar campanhas"}
              value={selectedNotificationGroups}
              onValueChange={setSelectedNotificationGroups}
            /> */}
              <Dropdown
                label={"Perfil:"}
                info={`Nível 1 - Administradores/Assessores da Savoy Signature\nNível 2 - Diretores SAVOY + Administradores AFAVIAS/CTM/INERTES\nNível 3 - Colaboradores das empresas detidas pelo Grupo AFA + Administração e Direções das empresas participadas\nNível 4 - Colaboradores das empresas participadas`}
                placeholder={"Escolher perfil"}
                items={profiles}
                value={profile}
                onValueChange={setProfile}
              />
              <div className={styles.formBlockSection}>
                <p>Data de nascimento:</p>
                <input
                  type="date"
                  value={birthday}
                  onChange={(e) => setBirthday(e.target.value)}
                />
              </div>
              {
                alreadyHasUniqueId ? ""
                  :
                  <div className={styles.formBlockSection}>
                    <p>Unique identifier:</p>
                    <input
                      value={uniqueId}
                      onChange={(e) => setUniqueId(e.target.value)}
                    />
                  </div>
              }
              <div className={styles.formBlockSection} style={{ padding: "0.5rem 1rem", width: "fit-content" }}>
                <p>Acesso ao backoffice:</p>
                <Switch value={accessBackoffice} setValue={setAccessBackoffice} setValuesOnDisabled={setPermissions} valuesOnDisabled={permissions} />
              </div>
            </div>
            {
              accessBackoffice ?
                <div>
                  <h3 style={{ marginBottom: 0 }}>Permissões de backoffice</h3>
                  <p style={{ marginTop: "10px" }}>As permissões tratam-se da criação, alteração e remoção dos dados das respetivas categorias.</p>
                  <div className={styles.backofficePermissions}>
                    {
                      permissions.map((perm) =>
                        <div key={perm.id} className={styles.formBlockSection} style={{ padding: "0.5rem 1rem", width: "fit-content" }}>
                          <p>{perm.display_name}:</p>
                          <Switch value={perm.value} values={permissions} setValues={setPermissions} notSetStateValue={perm} notSetState={true} />
                        </div>
                      )
                    }
                  </div>
                </div>
                : ""
            }
            {
              id ?
                <button className={styles.btn} type="" onClick={() => getAlertEdit()}>Guardar alterações</button>
                :
                <button className={styles.btn} type="" onClick={() => getAlertAdd()}>Adicionar funcionário</button>
            }
          </div>
      }
    </div>
  );
}

export default EditarFuncionarios;